import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Pin extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M8,8.9c0.7,0,1.6,0.1,2.4,0.4c0.5,0.2,1,0,1.3-0.3c0.7-0.7,1.5-1.5,2.2-2.2c0.3-0.3,0.4-0.6,0.3-1c-0.1-0.7,0-1.3,0.1-1.9
                    c0.2-0.6,0.4-1.1,0.8-1.6c0.2-0.3,0.6-0.3,0.8,0c2,2,3.9,3.9,5.9,5.9c0.3,0.3,0.2,0.6-0.1,0.8c-0.3,0.2-0.5,0.4-0.8,0.5
                    c-0.7,0.4-1.5,0.5-2.3,0.4c-0.3,0-0.6-0.2-0.8,0c-0.2,0.1-0.3,0.2-0.5,0.3c-0.7,0.7-1.5,1.4-2.2,2.2c-0.4,0.4-0.5,0.9-0.4,1.5
                    c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.4,0.1,0.9,0,1.3c-0.1,0.5-0.2,1.1-0.3,1.6c-0.3,0.9-0.7,1.8-1.4,2.5c-0.1,0.1-0.3,0.2-0.5,0.2
                    c-0.1,0-0.2-0.1-0.3-0.2c-1.2-1.2-2.3-2.3-3.5-3.5c-0.2-0.2-0.4-0.2-0.6,0c-0.9,0.9-1.9,1.7-2.9,2.6c-0.6,0.6-1.3,1.1-1.9,1.7
                    c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2,0.2-0.6,0.2-0.7,0C2.2,21.7,2,21.6,2,21.4c0-0.2,0.1-0.4,0.2-0.5c0.5-0.5,1-1.1,1.4-1.6
                    c0.6-0.7,1.2-1.4,1.8-2.1c0.4-0.5,0.9-1,1.3-1.5c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0-0.3c-0.1-0.1-0.2-0.2-0.3-0.3
                    c-1.1-1.1-2.2-2.2-3.3-3.3c-0.3-0.3-0.2-0.7,0.1-0.9c0,0,0.1-0.1,0.1-0.1c0.6-0.5,1.2-0.8,1.9-1.1C6.4,9,7.1,8.9,8,8.9z"
                />
            </SvgIcon>
        );
    }
}

export default Pin;
